import { TreeDotsIcon } from "components/ui/icons/threeDots/ThreeDots"
import style from "./ButtonOptions.module.scss"

const { buttonOptions, cssIconVariant } = style

type Props = {
	className?: string
	style?: React.CSSProperties
	fillColor?: string
	/**
	 * Draw the three-dots glyph with a CSS mask instead of an inline `<svg>`.
	 *
	 * The SVG costs 4 DOM nodes per button, which is irrelevant normally but adds
	 * up to thousands in a table with one options button per row. The CSS variant
	 * uses a pseudo-element, so it costs none. Note it renders no `ThreeDotsIcon`
	 * test id — only opt in where nothing depends on that.
	 */
	cssIcon?: boolean
	ariaLabel?: string
}

export const ButtonOptions = ({ className = "", style = {}, fillColor, cssIcon = false, ariaLabel }: Props) => {
	if (cssIcon) {
		// The glyph is a pseudo-element, so this button has no child content at all —
		// the label is the only accessible name it can have.
		return (
			<button
				className={`${className} ${buttonOptions} ${cssIconVariant}`}
				style={style}
				data-testid="button-options"
				aria-label={ariaLabel}
			/>
		)
	}

	return (
		<button className={`${className} ${buttonOptions}`} style={style} data-testid="button-options" aria-label={ariaLabel}>
			<TreeDotsIcon fillColor={fillColor} />
		</button>
	)
}
